
interface PauseIconProps {
    className?: string;
}


export function PauseIcon({ className }: PauseIconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24">
            <path d="M6 19h4V5H6zm8-14v14h4V5z" />
        </svg>
    );
}
